import type { Components } from '@mui/material/styles';

export default function MuiStep(): Components['MuiStep'] {
  return {};
}
